<template>
  <div id="app">
    <!-- <v-header></v-header> -->
    <router-view />
    <!-- <v-footer></v-footer> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  components:{
  }
}
</script>
<style lang="scss">
	/*每个页面公共css */
	/* 项目中图标来自阿里图标库 */
	// @import './css/iconfont.css';
	$theme_color: #DB3523;
	$font_size: 28px;

	body {
		font-size: $font_size;
		color: #333333;
		background-color: #f9f9f9;
	}
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		height: 100%;
	}
	button::after{
		border: none;
	}
	image {
		will-change: transform;
	}

	.mar-rig {
		margin-right: 10px;
	}

	.pos-rel {
		position: relative;
	}

	.flex {
		display: flex;
	}

	.flex-column {
		flex-direction: column;
	}
	.flex-nowrap{
		flex-wrap: nowrap;
	}
	.flex-wrap{
		flex-wrap: wrap;
	}
	.flex-1 {
		flex: 1;
	}

	.inline-flex {
		display: inline-flex;
	}
	.flex-shrink{
		flex-shrink: 0;
	}

	.justify-between {
		justify-content: space-between;
	}

	.justify-around {
		justify-content: space-around;
	}

	.justify-center {
		justify-content: center;
	}

	.align-center {
		align-items: center;
	}

	.text-center {
		text-align: center;
	}

	.text-right {
		text-align: right;
	}

	.bor-sel {
		border: 1rpx solid $theme_color;
	}
	
	// 主题颜色背景
	.bg-sel {
		background-color: $theme_color;
	}

	//按钮禁止的背景色
	.bg-disable{
		background-color: #B2B2B2;
		color: #fff;
	}

	// 白色背景
	.bg-white {
		background-color: #fff;
	}

	.box-border {
		box-sizing: border-box;
	}
	.bor-rad {
		border-radius: 10px;
	}

	// 去除滚动条
	/* ::-webkit-scrollbar {
		width: 0;
		height: 0;
		color: transparent;
	} */

	// 多余省略
	.ellipsis {
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.img{
		width: 100%;
	}
	//移动端垂直居中
	.line-height{
		display: flex;
		justify-content: center;
		align-items: center;
	}


	.td-c1{
		background: #daeef3;
	}
	.td-c2{
		background: #ebf1de;
	}
	.td-c3{
		background: #dce6f1;
	}
	.td-c4{
		background: #e4dfec;
	}

</style>

